<app-navigator
  (goToMainContent)="viewportScroller.scrollToAnchor(MAIN_CONTENT_ID)"
></app-navigator>

<header class="it-header-wrapper header-custom">
  <app-header></app-header>
</header>

<main [id]="MAIN_CONTENT_ID">
  <ngx-ui-loader [fgsTemplate]="foregroundSpinner"></ngx-ui-loader>
  <div class="container" [class.mt-5]="alertManager.alertInstanced.length > 0">
    <div class="row">
      <div class="col-12">
        <ng-template #genericMessageRefContainer></ng-template>
      </div>
    </div>
  </div>
  <router-outlet
    class="siu-container"
    (activate)="onChangeEveryRoute()"
  ></router-outlet>
</main>

<app-footer></app-footer>

<ng-template #foregroundSpinner>
  <div class="container" loaderAccessibility>
    <div class="row">
      <div class="col-6 col-lg-3">
        <div class="progress-spinner progress-spinner-active">
          <span class="visually-hidden">{{
            "LOADING_CONTENT" | translate
          }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-center">
          <span #loadingLabel class="spinner-text">{{
            "LOADING" | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
